import "./styles.css";

const Product = ({ product, handleClick }) => {
  return (
    <li className="li-vitrine">
      <div
        className="div-img-card"
        // style={{
        //   backgroundImage: `url(${product.img})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        // }}
      >
        <img className="img-card" src={product.img} alt="imageCard"></img>
      </div>
      <h3 className="title-card">{product.name}</h3>
      <p className="category-card">{product.category}</p>
      <p className="price-card">{product.price}</p>
      <button className="button-card" onClick={() => handleClick(product.id)}>
        Adicionar
      </button>
    </li>
  );
};

export default Product;
